import { Component, OnInit, Input } from '@angular/core';
import { DbRecord } from '../db-record'
import { Project } from '../project'
import { RuntimeService } from '../runtime.service'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ArcService } from '../arc.service'
import { FileService } from '../file.service'
import { AdminService } from '../admin.service'

@Component({
  selector: 'app-upload-box',
  templateUrl: './upload-box.component.html',
  styleUrls: ['./upload-box.component.css']
})
export class UploadBoxComponent implements OnInit {
  @Input() dbRecord: DbRecord
  @Input() isSearchFilesUpload = false
  @Input() isBatchSearchUpload = false
  project: Project
  forDeletionFiles = new Set<string>()

  constructor(
    private rs: RuntimeService,
    private sanitizer: DomSanitizer,
    private arcs: ArcService,
    private fs: FileService,
    private ads: AdminService
  ) {
    this.project = this.rs.currentProject
  }

  ngOnInit() {

  }

  deleteFile(f) {
    this.forDeletionFiles.add(f['filename'])
  }

  confirmDeleteFile(f) {
    this.fs.deleteFile(f)
  }

  cancelDeleteFile(f) {
    this.forDeletionFiles.delete(f['filename'])
  }

  isPlannedForDeletion(f) {
    return this.forDeletionFiles.has(f['filename'])
  }

  displayFilename(fn) {
    let suffix = fn.split('.').pop()
    let prefix = fn.split('@')[0]
    return `${prefix}.${suffix}`
  }

  get uploadId() {
    if (this.isSearchFilesUpload)
      return "searchFilesUpload"
    if (this.isBatchSearchUpload)
      return "batchSearchUpload"
    return `${this.project.shortcut}::${this.dbRecord.id}`
  }

  get isUploadForm() {
    if (this.isSearchFilesUpload || this.isBatchSearchUpload)
      return true
    return this.fs.isUploadForm(this.uploadId)
  }

  switchUploadForm() {
    if (this.isSearchFilesUpload || this.isBatchSearchUpload)
      return this.ads.clearSwitches()
    this.fs.switchUploadForm(this.uploadId)
  }

  get files() {
    if (this.isSearchFilesUpload || this.isBatchSearchUpload)
      return ''
    return this.fs.files(this.dbRecord.id, this.project.shortcut)
  }

  get dbRecordParams() {
    return `<input type="hidden" name="idsuffix" value="${this.dbRecord.id}">`
  }

  get searchFilesParams() {
    if (this.isSearchFilesUpload)
      return `<input type="hidden" name="isSearchFilesUpload" value="true">`
    if (this.isBatchSearchUpload)
      return `<input type="hidden" name="isBatchSearchUpload" value="true">`
  }


  get iframe(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(`
    <iframe id='uploadIFrame'
        srcdoc='
  <form method="post" enctype="multipart/form-data"
  action="https://gae-test.ecomole.com/a2">
  <input type="hidden" name="type" value="searchManagerForm">
  <input type="hidden" name="u" value="${this.arcs.userNs}">
  <input type="hidden" name="project" value="${this.project.shortcut}">
  <input type="hidden" name="parent" value="${location.protocol}//${location.host}">
  ${this.isSearchFilesUpload || this.isBatchSearchUpload ? this.searchFilesParams : this.dbRecordParams}
  <div>
  <input type="file" id="filepicker" name="files" multiple />
  </div>
  <div>
  <button onclick="submit()">Submit</button>
  </div>
  </form>'></iframe>
  `)
  }

}



// WEBPACK FOOTER //
// ./src/app/upload-box/upload-box.component.ts